/**
 * True when the user is on a role dashboard onboarding flow (tutor or student).
 * Used to avoid subscription-gated prefetch and global subscription banners during setup.
 */
export function isOnboardingRoute(pathname) {
    const path = pathname ??
        (typeof window !== 'undefined' ? window.location.pathname : '');
    return path.includes('/onboarding');
}
